<template>
  <div class="contact-page">

    <section class="contact-info-section">
      <div class="contact-cards">
        <a class="contact-card" href="tel:063962137">
          <span class="contact-icon"><img src="/icons/telephone.png" alt="" aria-hidden="true"></span>
          <h2 class="contact-card-title">{{ $t('pages.contact.phone') }}</h2>
          <p class="contact-card-value">063/ 962-137</p>
          <span class="contact-card-cta">{{ $t('pages.contact.callCta') }}</span>
        </a>

        <a
          class="contact-card"
          href="https://www.google.com/maps/place/Mimoza+64,+Neum+88390/@42.9189757,17.6171307,17z/data=!3m1!4b1!4m6!3m5!1s0x134ba3ad1400223b:0x539ceda1ffe951f2!8m2!3d42.9189718!4d17.6197056!16s%2Fg%2F11vcvpmlhq?entry=ttu"
          target="_blank"
          rel="noopener"
        >
          <span class="contact-icon"><img src="/icons/pin.png" alt="" aria-hidden="true"></span>
          <h2 class="contact-card-title">{{ $t('pages.contact.address') }}</h2>
          <p class="contact-card-value">Mimoza 64, Neum BiH</p>
          <span class="contact-card-cta">{{ $t('pages.contact.directionsCta') }}</span>
        </a>

        <a class="contact-card" href="mailto:info@apartman-sentic.com">
          <span class="contact-icon"><img src="/icons/email.png" alt="" aria-hidden="true"></span>
          <h2 class="contact-card-title">{{ $t('pages.contact.mail') }}</h2>
          <p class="contact-card-value">info@apartman-sentic.com</p>
          <span class="contact-card-cta">{{ $t('pages.contact.emailCta') }}</span>
        </a>
      </div>
    </section>

    <section class="contact-map-section">
      <div class="section-header">
        <h2 class="section-title">{{ $t('pages.contact.mapTitle') }}</h2>
        <p class="section-subtitle">{{ $t('pages.contact.mapDesc') }}</p>
        <div class="section-underline"></div>
      </div>

      <div class="map-wrapper" data-aos="fade-up">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2921.813425653651!2d17.617130676537194!3d42.91897569960765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134ba3ad1400223b%3A0x539ceda1ffe951f2!2sMimoza%2064%2C%20Neum%2088390!5e0!3m2!1shr!2sba!4v1698486550206!5m2!1shr!2sba"
          width="600"
          height="450"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          title="Lokacija Apartmana Sentić na Google karti - Mimoza 64, Neum"
        ></iframe>
      </div>
    </section>
  </div>
</template>


<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'ContactComponent',
  setup() {
    const { t, locale } = useI18n();
    return {
      t,
      locale
    };
  }
}
</script>
<style scoped>
.contact-page {
  background: var(--color-bg);
}

/* Info cards */
.contact-info-section {
  padding: 90px 60px 40px;
}

.contact-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.contact-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: var(--color-surface);
  border-radius: var(--radius-md);
  padding: 45px 30px;
  box-shadow: var(--shadow-soft);
  border: 2px solid transparent;
  text-decoration: none !important;
  transition: all 0.4s var(--ease);
}

.contact-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-hover);
  border-color: var(--color-primary);
}

.contact-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--color-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 22px;
  transition: background 0.3s ease;
}

.contact-card:hover .contact-icon {
  background: var(--color-primary);
}

.contact-icon img {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.contact-card-title {
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: 600;
  color: var(--color-primary);
  margin: 0 0 8px;
}

.contact-card-value {
  font-size: 16px;
  color: var(--color-text);
  margin: 0 0 18px;
  word-break: break-word;
}

.contact-card-cta {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--color-accent);
}

/* Map section */
.contact-map-section {
  padding: 80px 60px 110px;
}

.section-header { text-align: center; margin-bottom: 60px; }
.section-title { font-family: var(--font-display); font-size: clamp(30px, 4vw, 42px); font-weight: 600; color: var(--color-primary); margin-bottom: 15px; letter-spacing: -0.5px; }
.section-subtitle { font-size: 16px; color: var(--color-text-muted); margin-bottom: 25px; max-width: 560px; margin-left: auto; margin-right: auto; }
.section-underline { width: 80px; height: 3px; background: linear-gradient(90deg, transparent, var(--color-accent) 20%, var(--color-accent) 80%, transparent); margin: 0 auto; }

.map-wrapper {
  max-width: 1100px;
  margin: 0 auto;
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-soft);
  filter: grayscale(0.25);
  transition: filter 0.4s ease;
}

.map-wrapper:hover {
  filter: grayscale(0);
}

.map-wrapper iframe {
  height: 480px;
  width: 100%;
  display: block;
}

@media (max-width: 1024px) {
  .contact-info-section { padding: 70px 40px 30px; }
  .contact-map-section { padding: 60px 40px 90px; }
}

@media (max-width: 768px) {
  .contact-info-section { padding: 50px 20px 20px; }
  .contact-map-section { padding: 50px 20px 60px; }
  .contact-card { padding: 35px 20px; }
  .map-wrapper iframe { height: 340px; }
}
</style>
